import { useFeatureFlag } from '@nx/state';

import { expiryTimeOptions as defaultExpiryTimeOptions, testExpiryTimeOptions } from '../shared/constants';
import type { TokenExpiryOption } from '../shared/types';

export const useTokenExpiryTimeOptions: () => TokenExpiryOption[] = () => {
  const [isTestTokenExpiryEnabled] = useFeatureFlag('ops:debug');

  return isTestTokenExpiryEnabled ? [...testExpiryTimeOptions, ...defaultExpiryTimeOptions] : defaultExpiryTimeOptions;
};
